
import React from 'react'

import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  DateInput,
  QuestionRadioButtonInput,
  SaveButton,
  TextInput
} from '../../../../../shared/FormBuilder'
import { Paper } from '../../../../../shared/NarusMaterial'

class GoalForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValue () {
    const values = { ...this.state.value }
    return values
  }

  handleSubmit () {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  render () {
    const disableSave = !this.state.value.goal
    return (
      <button
        style={{ width: '100%' }}
        onKeyDown={this.props.onKeyDown}
        className='margin-top margin-bottom'
      >
        <Paper>
          <div className='row'>
            <input
              type='hidden'
              name='id'
            />
            <div className='col-xs-12 col-sm-12 col-md-4'>
              <TextInput
                label='Goal'
                required
                name='goal'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4 mui-date-picker-extended'>
              <DateInput
                label='Date'
                name='date'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Location'
                name='location'
              />
            </div>
          </div>

          <QuestionRadioButtonInput
            question='Does the patient need Narus help achieving this goal?'
            radioButtons={YesNoRadioOptions}
            name='needsHelp'
          />

          <div className='row'>
            <div className='col-xs-12'>
              <TextInput
                label='Comments'
                name='comments'
              />
            </div>
          </div>

          <div className='row end-xs margin-top'>
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton
                noGlobal
                onClick={this.props.onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </button>
    )
  }
}

export default GoalForm
